import { render, staticRenderFns } from "./AdvertGroup.vue?vue&type=template&id=9daea3b0&scoped=true&"
import script from "./AdvertGroup.vue?vue&type=script&lang=js&"
export * from "./AdvertGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daea3b0",
  null
  
)

export default component.exports